"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeDistributionColumns = exports.AttributeDistributionColumns = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const attribute_distribution_styles_1 = require("../attribute-distribution.styles");
const localization_1 = require("../../../../localization");
var AttributeDistributionColumns;
(function (AttributeDistributionColumns) {
    AttributeDistributionColumns["Attribute"] = "attribute";
    AttributeDistributionColumns["Applied"] = "applied";
    AttributeDistributionColumns["NotApplicable"] = "notApplicable";
    AttributeDistributionColumns["Unknown"] = "unknown";
    AttributeDistributionColumns["Attributions"] = "total";
    AttributeDistributionColumns["AppliedToAttributionsRatio"] = "appliedToAttributionsRatio";
})(AttributeDistributionColumns || (exports.AttributeDistributionColumns = AttributeDistributionColumns = {}));
const useAttributeDistributionColumns = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const columns = (0, react_1.useMemo)(() => [
        {
            field: AttributeDistributionColumns.Attribute,
            headerName: t({ key: 'ATTRIBUTE' }),
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: AttributeDistributionColumns.Applied,
            headerName: t({ key: 'APPLIED' }),
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: AttributeDistributionColumns.NotApplicable,
            headerName: t({ key: 'NOT_APPLICABLE_SHORT' }),
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: AttributeDistributionColumns.Unknown,
            headerName: t({ key: 'UNKNOWN' }),
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: AttributeDistributionColumns.Attributions,
            headerName: t({ key: 'ATTRIBUTIONS' }),
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: AttributeDistributionColumns.AppliedToAttributionsRatio,
            headerName: '%',
            flex: 0.5,
            sortable: false,
            filterable: false,
            renderHeader: () => (react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, title: react_1.default.createElement(react_1.default.Fragment, null, t({ key: 'APPLIED' }), "/", react_1.default.createElement("br", null), t({ key: 'ATTRIBUTIONS' })) }, react_1.default.createElement("span", null, react_1.default.createElement(attribute_distribution_styles_1.StyledInfoIcon, null), " %"))),
            valueGetter: (_value, row) => {
                if (!row.total)
                    return '0%';
                return `${parseFloat(((row.applied / row.total) * 100).toFixed(2))}%`;
            },
        },
    ], [t]);
    return columns;
};
exports.useAttributeDistributionColumns = useAttributeDistributionColumns;
